import { render } from "./NavBarUnified.vue?vue&type=template&id=3456da82&scoped=true"
import script from "./NavBarUnified.vue?vue&type=script&lang=js"
export * from "./NavBarUnified.vue?vue&type=script&lang=js"

import "./NavBarUnified.vue?vue&type=style&index=0&id=3456da82&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3456da82"],['__file',"src/components/NavBarUnified.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3456da82"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3456da82', __exports__)) {
    api.reload('3456da82', __exports__)
  }
  
  module.hot.accept("./NavBarUnified.vue?vue&type=template&id=3456da82&scoped=true", () => {
    api.rerender('3456da82', render)
  })

}


export default __exports__